import React from 'react';
import MultiAgentView from './MultiAgentView';
import PatientInfectionMatches from './PatientInfectionMatches';
const names={infections:'Infection reports',pet_reports:'PET reports',adequacy_reports:'Adequacy reports'};
export default function PatientCaseView({result,api,disabled,onPage,onInfections}){
 return <div className="space-y-4">
  <p className="text-sm">{result.case_basis}</p>
  <details open><summary className="font-semibold cursor-pointer">Patient record</summary><dl className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">{Object.entries(result.patient||{}).map(([k,v])=><div key={k} className="rounded border p-2 break-words"><dt className="font-semibold">{k.replace(/_/g,' ')}</dt><dd>{v==null||v===''?'Not recorded':String(v)}</dd></div>)}</dl></details>
  {(result.sections||[]).map(section=><section key={section.type} className="rounded border p-3 space-y-2" aria-label={names[section.type]}>
   <h3 className="font-semibold">{names[section.type]}</h3>
   {section.status==='unavailable'?<p>{section.message}</p>:<>
    <p>{section.result.answer}</p>
    {section.type==='infections'?<PatientInfectionMatches result={section.result} disabled={disabled} onNext={offset=>onInfections({...section.result.pageQuery,offset})}/>:<MultiAgentView result={section.result} api={api} disabled={disabled} onPage={onPage}/>}
   </>}
  </section>)}
 </div>;
}
